import { MenuItem, Popover, Typography } from "@mui/material";

interface ListMenuContentItem {
  name: string;
  color: string;
  icon: React.ReactNode;
  action: () => void;
}

interface ListTableRowMenuProps {
  menuItems: ListMenuContentItem[];
  anchorElement: Element | undefined;
  handleCloseMenu: () => void;
}
export const ListTableRowMenu = ({
  menuItems,
  anchorElement,
  handleCloseMenu,
}: ListTableRowMenuProps) => {
  return (
    <Popover
      open={Boolean(anchorElement)}
      anchorEl={anchorElement}
      onClose={handleCloseMenu}
      anchorOrigin={{ vertical: "top", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{
        sx: {
          p: 1,
          width: 140,
          "& .MuiMenuItem-root": {
            px: 1,
            typography: "body2",
            borderRadius: 0.75,
          },
        },
      }}
    >
      {menuItems.map((m, index) => {
        return (
          <MenuItem
            key={`menu-item-${index}`}
            sx={{ color: m.color }}
            onClick={() => {
              handleCloseMenu();
              m.action();
            }}
          >
            {m.icon}
            <Typography ml={1}>{m.name}</Typography>
          </MenuItem>
        );
      })}
    </Popover>
  );
};
